var _module = require('../../components/module');

require('angular-ui-bootstrap/src/modal');
require('../user');
require('../lr-touch');
require('angular-ui-utils-mask');

_module.requires.push(
    'ui.bootstrap.module.modal',
    'ui.mask'
);

_module.service('$editUserPropertyModal', [
    '$log',
    '$location',
    '$user',
    '$uibModal',
    '$timeout',
    '$fsloading',

    function $editUserPropertyModalService($log, $location, $user, $uibModal, $timeout, $fsloading) {
        /*
        @function openAddEmailModal
        */
        return function openAddEmailModal(keyName, oldValue) {
            var modal = $uibModal.open({
                template: require('./index.html'),
                controller: ['$scope', function addEmailModalCtrl($scope) {

                    var verifiedAccountCheck = function () {

                        // update the user's account type
                        // if all devices are unverified

                        if( $user.verified ) {
                            var devices = Object.keys($user.verified);
                            var verifiedDevices = devices.filter(function (device, i) {
                                return !!($user.verified[device]);
                            });

                            if(verifiedDevices.length === 0) {
                                $user.account_type = 'unverified';
                            }
                        }
                    };

                    var modifyUserObj = function (str) {

                        if(keyName == 'full_name') {
                            var name = str.split(' ');
                            var firstName = name.shift().trim();
                            var lastName = name.join(' ').trim();
                            var fullName = firstName + ' ' + lastName;
                            $user.first_name = firstName;
                            $user.last_name = lastName;
                            $user.full_name = fullName;
                        } else {
                            $user[keyName] = str;
                        }

                        // check if user's phone or email is being updated
                        // if so we need to mark it as unverified

                        if( ['phone', 'email'].indexOf(keyName) >= 0 &&
                            oldValue !== $scope.editConfig.newValue ){

                            if( $user.verified &&
                                $user.verified.hasOwnProperty(keyName) ){

                                $user.verified[keyName] = false;
                                verifiedAccountCheck();
                            }
                        }
                    };

                    var sendVerificationMessage = function (response) {
                        switch(keyName) {
                            case 'phone':
                                return $user.sendPhoneVerification($location.absUrl());

                            case 'email':
                                return $user.sendEmailVerification($location.absUrl());

                            default:
                                return response;
                        }
                    };

                    var onSaveSuccess = function (response) {
                        var msg;
                        switch(keyName) {
                            case 'phone':
                                msg = 'We\'ve sent a verification text to the phone number you\'ve provided. Once you confirm, your notification settings will be set.';
                                break;

                            case 'email':
                                msg = 'We\'ve sent a verification email to the address you\'ve provided. Once you confirm, your notification settings will be set.';
                                break;

                            default:
                                msg = 'Your information has been updated successfully.';
                                break;
                        }

                        $scope.$close({response: response, msg: msg});
                    };

                    var onSaveError = function (err) {
                        $log.error('Something went wrong while trying to save ', keyName, err);
                        $scope.$dismiss(err);
                    };

                    var saveEdit = function (str) {
                        if(str && str.length > 0) {

                            $fsloading.show();
                            modifyUserObj(str);
                            $user.save()
                                .then(sendVerificationMessage)
                                .then(onSaveSuccess)
                                .catch(onSaveError)
                                .finally(function () {
                                    $fsloading.hide();
                                });
                        }
                    };

                    var initUserObj = function () {
                        $scope.usr = $user;
                    };

                    var humanize = function (keyName) {
                        var h = {
                            'full_name': 'Full Name',
                            'email': 'Email Address',
                            'phone': 'Phone Number'
                        };

                        return (h.hasOwnProperty(keyName))
                            ? h[keyName]
                            : keyName.replace(/_/g, ' ');
                    };

                    var init = function () {
                        initUserObj();

                        $scope.editConfig = {
                            keyName: keyName,
                            humanKeyName: humanize(keyName),
                            oldValue: oldValue,
                            newValue: oldValue || ''
                        };
                    };

                    init();


                    /// PUBLIC API

                    $scope.submitEdit = function (val) {
                        if($scope.usr && $scope.usr.hasOwnProperty(keyName)){
                            if(val !== oldValue) {
                                $log.debug('Saving', keyName, val);
                                $timeout(function () {
                                    saveEdit(val);
                                }, 10);
                            }else{
                                $scope.$close();
                            }
                        }else {
                            $log.debug('Couldn\'t edit property ', keyName);
                        }
                    };

                }],
                backdrop: 'static',
                keyboard: false,
                windowClass: 'edit-user-property-modal'
            });

            return modal.result;
        };
    }
]);
